const ACTION_TYPES = {
  PREVIEW: 'preview',
  READ_ONLY: 'read_only',
  NO_CHANGE: 'no_change',
  UPDATE: 'update',
  SAVE: 'save',
  CANCEL: 'cancel',
  BACK: 'back',
};

export default ACTION_TYPES;

export const determineActionType = (readOnlySurvey, changeIds, edit) => {
  if (readOnlySurvey) {
    return ACTION_TYPES.READ_ONLY;
  }
  if (edit) {
    return ACTION_TYPES.UPDATE;
  }
  if (changeIds.length === 0) {
    return ACTION_TYPES.NO_CHANGE;
  }
  return ACTION_TYPES.SAVE;
};
